import { canv } from "@/canv/global";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeCloud extends Shape {
    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY =
            y + this.getTextLineHeight(textPart) + height / 1.65 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        canv.ctx.beginPath();
        canv.ctx.ellipse(
            x + w * (8 / 24),
            y + h * (12 / 24),
            w * (8 / 24),
            h * (8 / 24),
            0,
            1.6,
            Math.PI * 1.9,
        );
        canv.ctx.ellipse(
            x + w * (18 / 24),
            y + h * (15 / 24),
            w * (5 / 24),
            h * (5 / 24),
            0,
            4.28,
            Math.PI * 2.5,
        );
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" fill="none" viewBox="0 0 24 24">
                <path
                    fill="${fill}"
                    stroke="${stroke}"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M18.05 19.7H8.7a7.7 7.7 0 1 1 7.38-9.9h1.97a4.95 4.95 0 1 1 0 9.9Z"
                />
            </svg>
        `;
    }
}
